var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"camps-page"},[_c('router-view'),(_vm.isPending)?_c('div',{staticClass:"preloader-gif"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }